const getRangeProgressValue = (start, end, current, sectionsCount) =>
  start + (current * (end - start)) / sectionsCount;

export default getRangeProgressValue;
